import React from "react";

import I18n from "pro-features/components/WithTranslation/src/I18n";
import {
    SegmentsWarningBannerContentPrimary,
    SegmentsWarningBannerContentSecondary,
} from "app/pages/segments/wizard/SegmentWizard/SegmentWizardStyles";
import type { ICustomSegmentAvailableMembers } from "app/services/segments/SegmentsUtils";

import { SegmentsVsGroupOvertime } from "./components/benchmarkOvertime/SegmentsVsGroupOvertime";
import {
    SegmentsAnalysisContainer,
    StyledSegmentsWarningBannerContainer,
    StyledSegmentsWarningBannerContent,
} from "./StyledComponents";

const WarningBannerMissingData: React.FC = () => {
    return (
        <StyledSegmentsWarningBannerContainer>
            <StyledSegmentsWarningBannerContent>
                <SegmentsWarningBannerContentPrimary>
                    <I18n>segment.group.analysis.missing.response.warning.primary</I18n>
                </SegmentsWarningBannerContentPrimary>
                <SegmentsWarningBannerContentSecondary>
                    <I18n>segment.group.analysis.missing.response.warning.secondary</I18n>
                </SegmentsWarningBannerContentSecondary>
            </StyledSegmentsWarningBannerContent>
        </StyledSegmentsWarningBannerContainer>
    );
};

interface ICategoryOverviewProps {
    pageFilters?: any;
    loading: boolean;
    data?: any;
    components: any;
    selectedRows: any;
    graphData: any;
    tableData: any;
    availableMembers: ICustomSegmentAvailableMembers;
    onGraphDDClick: (props: FixmeType) => void;
    tableExcelLink: string;
    getAssetsUrl: (a: FixmeType) => string;
    timeGranularity?: string;
    responseMissingData?: any[];
    tableDataOmitted?: any[];
    setSelectedTab: any;
}

export const SegmentsGroupAnalysisOverview: React.FC<ICategoryOverviewProps> = ({
    components,
    loading,
    pageFilters,
    selectedRows,
    graphData,
    onGraphDDClick,
    tableExcelLink,
    tableData,
    availableMembers,
    timeGranularity,
    responseMissingData,
    tableDataOmitted,
    setSelectedTab,
}) => {
    const showWarningMissingData = (responseMissingData?.length ?? 0) > 0;

    const fullTableData = React.useMemo(() => {
        return (
            tableData && {
                ...tableData,
                // @ts-ignore FIXME: strict migration - 'tableDataOmitted' possibly undefined — caller always provides tableDataOmitted alongside tableData
                Data: tableDataOmitted.reduce(
                    (acc, tableDataItem) => {
                        return {
                            ...acc,
                            [tableDataItem.SegmentId]: {
                                ...tableDataItem,
                                isDisabled: true, // do not show data cells
                                HasGraphData: false, // to disable row selection
                                rowClass: "segmentRowDisabled", // grey out
                            },
                        };
                    },
                    { ...tableData.Data },
                ),
            }
        );
    }, [tableData, tableDataOmitted]);

    const { SegmentsGroupAnalysisTableContainer, GraphSwitcherComponent } = components;
    const SegmentsVsGroupProps = {
        title: "segments.group.analysis.title",
        titleTooltip: "segments.group.analysis.title.tooltip",
        filters: pageFilters,
        data: graphData,
        selectedRows,
        isLoading: loading,
        onGraphDDClick,
        tableExcelLink,
        rowSelectionProp: "SegmentId",
        availableMembers,
        selectedGranularity: timeGranularity,
        setSelectedTab,
        SwitcherComponent: GraphSwitcherComponent,
    };

    const tableProps = {
        isLoading: loading,
        tableData: fullTableData,
        selectedRows,
        availableMembers,
        tableSelectionKey: "SegmentsGroupAnalysisTable",
        tableSelectionProperty: "SegmentId",
    };

    return (
        <>
            {showWarningMissingData ? <WarningBannerMissingData /> : null}
            <SegmentsAnalysisContainer>
                <SegmentsVsGroupOvertime {...SegmentsVsGroupProps} />
                <SegmentsGroupAnalysisTableContainer {...tableProps} />
            </SegmentsAnalysisContainer>
        </>
    );
};
